import { AxiosResponse } from "axios";
import { axiosClient } from "../../axiosClient";
import { axiosSafeRequest } from "../../axiosSafeRequest";

/**
 * Request a magic-link sign-in email for a given licence key and address.
 *
 * @param licenceKey The Cryptolens licence key.
 * @param email The recipient email address. Must share a domain with the licence owner.
 * @returns An HTTP response.
 */
export const apiAccountLoginPost = async (licenceKey: string, email: string): Promise<AxiosResponse | undefined> => {
  return axiosSafeRequest(() => axiosClient.post('/account/login', { licenceKey, email }));
}
